import React from "react"
import { Add } from "@mui/icons-material"
import { Stack, Tooltip, IconButton } from "@mui/material"
import { useCreateTag, useToggleView } from "../../hooks"
import { SelectBoxOption } from "../../interfaces"
import { useAppDispatch } from "../../redux"
import { updateBoardStateByKey } from "../../redux/slices/board"
import { HighlightSelectBox } from "../highLightSelectBox"
import { ConvertToReactSelect } from "../../utils"
import { EntityType } from "../boardLayout/types";
import { CheckListData } from "../../screens/viewCheckList/viewCheckListDetail"

export const TagCategoriesDropdown: React.FC<{ entity: EntityType, tagGroupResponse: CheckListData, refetchTagGroups: () => void }> = React.memo(({ entity, tagGroupResponse, refetchTagGroups }) => {
    const dispatch = useAppDispatch();

    const createTag = useCreateTag();

    const { selectedBoard } = useToggleView(entity);

    const isLoading = tagGroupResponse.isFetching || tagGroupResponse.isLoading;

    const boardOptions = React.useMemo(() => {
        if (tagGroupResponse?.isSuccess) {
            let options = ConvertToReactSelect(tagGroupResponse?.data?.data ?? [], '_id', 'tag_group_name');

            const foundOption = options.find(b => b?._id === selectedBoard?._id);

            if (selectedBoard && !foundOption) {
                dispatch(updateBoardStateByKey({ key: "selectedBoard", value: null, entity: entity }));
            } else if (options.length > 0 && !selectedBoard) {
                dispatch(updateBoardStateByKey({ key: "selectedBoard", value: options[0], entity: entity }));
            }
            
            return options;
        }
        return [];
        // eslint-disable-next-line
    }, [isLoading, selectedBoard?._id]);

    return (
        <Stack height={"100%"} justifyContent={'flex-end'} alignItems={"center"} direction="row" spacing={1} sx={{ position: "relative" }}>
            <HighlightSelectBox
                sx={{
                    bgcolor: "white",
                    width: { lg: 250, md: 250, sm: 250, xs: "100%" }
                }}
                margin={"none"}
                label={""}
                placeholder={"Please select the value"}
                value={selectedBoard}
                options={boardOptions}
                onChange={(data: SelectBoxOption) => dispatch(updateBoardStateByKey({ key: "selectedBoard", value: data, entity: entity }))}
                disableClearable
            />

            <Tooltip title={`Create a tag for ${selectedBoard?.label}`}>
                <IconButton
                    color="primary"
                    onClick={() => createTag(refetchTagGroups, selectedBoard as SelectBoxOption)}
                    size="small"
                    sx={{ position: "absolute", right: '32px' }}
                >
                    <Add htmlColor="primary" fontSize="small" />
                </IconButton>
            </Tooltip>
        </Stack>
    )
});
